import { TootHeading } from "../../../../modules/layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import { ContactFormBlockClient } from "./ContactFormBlock.client";
import type { IContactFormBlockProps } from "./ContactFormBlock.props";

export const ContactFormBlock = (props: IContactFormBlockProps) => {
  const {
    anchorId,
    errorMessage,
    eyebrow,
    heading,
    parentClass,
    spacing,
    submitLabel,
    subheading,
    successMessage,
  } = props;

  if (!submitLabel || !successMessage || !errorMessage) {
    return null;
  }

  const header =
    heading || eyebrow || subheading ? (
      <TootHeading alignment="left" eyebrow={eyebrow} heading={heading} subheading={subheading} />
    ) : null;

  return (
    <TootSectionShell
      className="grid min-w-0 gap-8 lg:grid-cols-[minmax(16rem,0.38fr)_minmax(0,1fr)] lg:items-start lg:gap-12 xl:gap-16"
      id={anchorId ?? undefined}
      rootClassName={parentClass}
      spacing={spacing ?? undefined}
      tone="default"
      width="wide"
    >
      <div className="min-w-0 lg:sticky lg:top-28">{header}</div>
      <ContactFormBlockClient {...props} />
    </TootSectionShell>
  );
};

ContactFormBlock.displayName = "Block::ContactFormBlock";
